

import React,{useState,useEffect} from "react";
import { useDispatch } from "react-redux";

import { useSelector } from "react-redux";
import {Minus,Activity ,ChevronLeft,X,Plus ,Phone,Check,BadgePlus} from 'lucide-react';
  
  
const SettingsCourseCardFeatures= ({value,closeCourseExpiryType})=>{ 

     const dispatch = useDispatch();
     const [snackbarVisible, setSnackbarVisible] = useState(false);
    return(<>
	       CourseCardFeatures                   
    </>)  
}
export default SettingsCourseCardFeatures;